<template>
<div id="pageTable">
  <v-card>
    <v-container grid-list-xl fluid>
   
        <v-layout row wrap class="custom-mb">
            <v-flex sm12>
                
                    <v-toolbar card color="white">
                        <v-toolbar-title>
                            <h3>Post Load</h3>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <router-link class="link-btn white-text"  :to="{name: 'Loads'}">
                            <v-icon color="white">fa-cube</v-icon><span>
                            MY LOADS</span>
                        </router-link>
                    </v-toolbar>
                    <breadcrumbs :items="breadcrumbs" divider=">"></breadcrumbs>
                    <v-divider></v-divider>
                    <v-dialog v-model="showTemplateModal" v-if="showTemplateModal" max-width="40%" scrollable>
                        <v-card>
                            <v-toolbar dark color="orange">
                                <v-toolbar-title>Create Template</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon dark @click="showTemplateModal=false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <v-layout row wrap>
                                    <v-flex lg12 md12 xs12>
                                        <v-text-field label="Template Name" v-model="form.template_name" data-vv-name="template_name" data-vv-as="Template Name" :maxlength="30" placeholder="" v-validate="this.showTemplateModal ? {required:'form.template_name','restrictedWord':[]} : false" :error-messages="errors.collect('template_name')">
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <div class="text-xs-right">
                                    <v-btn color="red white--text" @click="showTemplateModal=false"> Cancel </v-btn>
                                    <v-btn color="green white--text" @click="submit()"> Save </v-btn>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                    <v-card-text class="pa-0">
                        <v-form>
                            <v-container grid-list-xl fluid>
                                <v-layout row wrap v-if="showTemplates">
                                    <v-flex lg12 md12 xs12>
                                        <v-select @input="onTemplateChange" :items="templates" data-vv-name="templates" v-model="form.template_id" data-vv-as="Templates" item-text="template_name" item-value="uuid" label="Load Template">
                                        </v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex lg2 md2 xs6>
                                        <v-switch @change="isRecurringChange" label="Recurring"  v-model="form.is_recurring"></v-switch>
                                    </v-flex>
                                    <template v-if="form.is_recurring">
                                        <v-flex lg2 md2 xs12>
                                            <v-select :items="frequency" :error-messages="errors.collect('frequency')" @change="changeFrequency" data-vv-name="frequency" v-model="form.frequency" v-validate="{'endDateValidationForFrequency':[form.end_date, form.pickup_date, form.is_recurring]}" data-vv-as="Recurring Type" item-text="text" item-value="value" label="Recurring Type">
                                            </v-select>
                                        </v-flex>                                        
                                        <v-flex lg3 md3 xs12>
                                            <v-menu ref="picker_pickup_date" lazy :close-on-content-click="false" v-model="form.picker_pickup_date" transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px" :return-value.sync="form.pickup_date">
                                                <v-text-field 
                                                    class="custom-picker-text" 
                                                    id="pickup_date" 
                                                    v-validate="'required'" 
                                                    :error-messages="errors.collect('pickup_date')" 
                                                    slot="activator" 
                                                    label="Pickup Date *" 
                                                    :value="displayDate(form.pickup_date,'pickup')" prepend-icon="event" 
                                                    readonly
                                                    data-vv-name="pickup_date_1"
                                                >
                                                </v-text-field>
                                                <v-date-picker :min="minDate" data-vv-name="pickup_date" data-vv-as="Pickup Date" v-validate="{endDateValidationForPickup:[form.end_date, form.frequency, form.is_recurring]}" v-model="form.pickup_date" no-title scrollable @input="changePickerDate(); $refs.picker_pickup_date.save(form.pickup_date)">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex lg3 md3 xs12>
                                            <v-menu ref="picker_end_date" lazy :close-on-content-click="false" v-model="form.picker_end_date" transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px" :return-value.sync="form.end_date">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field 
                                                        class="custom-picker-text" 
                                                        id="end_date" 
                                                        :error-messages="errors.collect('end_date')"
                                                        slot="activator" 
                                                        label="End Date *" 
                                                        :value="displayDate(form.end_date,'pickup')" prepend-icon="event" 
                                                        readonly
                                                        data-vv-name="end_date_1"
                                                        v-on="on"
                                                    >
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker :min="minDate" data-vv-as="End Date" data-vv-name="end_date" v-validate="{endDateValidation:[form.pickup_date, form.frequency, form.is_recurring]}" v-model="form.end_date" no-title scrollable @input="$refs.picker_end_date.save(form.end_date)">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex lg2 md2 xs12>
                                            <v-text-field label="Load ID" :maxlength="64" v-model="form.reference_number" v-validate="{'max': 30,alpha_dash:true,'restrictedWord':[]}" data-vv-name="reference_number" placeholder="" :error-messages="errors.collect('reference_number')" required data-vv-as="Load Id">
                                            </v-text-field>
                                        </v-flex> 
                                    </template>                                                                       
                                </v-layout>                                
                                <v-layout row wrap>
                                    <template v-if="!form.is_recurring">
                                        <v-flex lg6 md6 xs12 theme--light>
                                            <v-menu
                                                ref="picker_muiti_pickup_date"
                                                :close-on-content-click="false"
                                                v-model="form.picker_muiti_pickup_date"
                                                :return-value.sync="form.muiti_pickup_date"
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"                                                
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-combobox
                                                        v-model="muiti_pickup_date_chips"
                                                        multiple
                                                        chips
                                                        small-chips
                                                        id="muiti_pickup_date_chips"
                                                        data-vv-name="muiti_pickup_date_chips"
                                                        data-vv-as="Pickup Date"
                                                        :error-messages="errors.collect('muiti_pickup_date_chips')"
                                                        label="Pickup Date *" 
                                                        prepend-icon="event"
                                                        readonly
                                                        v-on="on"
                                                        class="multiDatePic"
                                                        v-validate="'required'" 
                                                    ></v-combobox>
                                                </template>
                                                <v-date-picker :min="minDate" @input="changeMultiDate()" v-model="form.muiti_pickup_date" multiple no-title scrollable >
                                                    <v-spacer></v-spacer>
                                                    <v-btn text color="orange white--text" @click="$refs.picker_muiti_pickup_date.save(form.muiti_pickup_date)">OK</v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex lg6 md6 xs12>
                                            <v-text-field label="Load ID" :maxlength="64" v-model="form.reference_number" v-validate="{'max': 30,alpha_dash:true,'restrictedWord':[]}" data-vv-name="reference_number" placeholder="" :error-messages="errors.collect('reference_number')" required data-vv-as="Load Id">
                                            </v-text-field>
                                        </v-flex>
                                    </template>
                                </v-layout>                                
                                <v-layout row wrap>
                                    <v-flex lg12 md12 xs12>
                                        <v-text-field label="Origin *" class="white-placeholder" autocomplete="off" v-model="form.origin_address" v-validate="{required: true,origin_address: [hidden_origin_address], origin_city_check: [hidden_origin_city, hidden_origin_state]}" id="origin_address" data-vv-name="origin_address" data-vv-as="Origin Address" placeholder="" required :error-messages="errors.collect('origin_address')" @input="getAddressData('origin')">
                                        </v-text-field>
                                    </v-flex>
                                    <input :type="'hidden'" v-model="hidden_origin_address" ref="hidden_origin_address" data-vv-name="hidden_origin_address">
                                    <input :type="'hidden'" v-model="hidden_origin_city" ref="hidden_origin_city" data-vv-name="hidden_origin_city">
                                    <input :type="'hidden'" v-model="hidden_origin_state" ref="hidden_origin_state" data-vv-name="hidden_origin_state">
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex lg12 md12 xs12>
                                        <v-text-field label="Destination *" class="white-placeholder" autocomplete="off" v-model="form.dest_address" v-validate="{required:true,dest_address: [hidden_dest_address], dest_city_check: [hidden_dest_city, hidden_dest_state], dest_address_mismatch:[form.origin_lat,form.origin_lng, form.dest_lat,form.dest_lng]}" id="dest_address" data-vv-name="dest_address" data-vv-as="Destination Address" placeholder="" required :error-messages="errors.collect('dest_address')" @input="getAddressData('dest')">
                                        </v-text-field>
                                        <input :type="'hidden'" v-model="hidden_dest_address" ref="hidden_dest_address" data-vv-name="hidden_dest_address">
                                        <input :type="'hidden'" v-model="hidden_dest_city" ref="hidden_dest_city" data-vv-name="hidden_dest_city">
                                        <input :type="'hidden'" v-model="hidden_dest_state" ref="hidden_dest_state" data-vv-name="hidden_dest_state">
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex lg6 md6 xs12>
                                        <v-autocomplete class="auotchoice" :items="equipment_types" v-validate="{required:'form.equipment_types'}" :error-messages="errors.collect('equipment_types')" data-vv-name="equipment_types" data-vv-rules="equipment_types" v-model="equipment_type_id_list" required :readonly="!showEquipmentTypes ? true : false" data-vv-as="Equipment Types" item-text="name" item-value="code" label="Equipment Types *" multiple v-on:change="onEquipmentChange"></v-autocomplete>
                                    </v-flex>
                                    <v-flex lg6 md6 xs12>
                                        <v-select class="custom_dropdown" v-validate="'required'" :items="load_size_arr" :error-messages="errors.collect('load_size')" data-vv-name="load_size" v-model="form.load_size" required data-vv-as="Load Size" item-text="name" item-value="id" label="Load Size *">
                                        </v-select>
                                    </v-flex>
                                </v-layout>
                                <v-expand-transition>
                                    <div v-if="showAdvancedField">
                                        <v-layout row wrap>
                                            <v-flex lg4 md4 xs12>
                                                <v-text-field label="Weight (lbs)" v-model="form.weight" v-validate="{decimal:2, decimal_digit6: 'form.weight'}" data-vv-name="weight" placeholder="" :error-messages="errors.collect('weight')" required data-vv-as="Weight">
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex lg4 md4 xs12>
                                                <v-text-field label="Height (ft)" v-model="form.height" v-validate="{decimal:2, decimal_digit: 'form.height'}" data-vv-name="height" placeholder="" :error-messages="errors.collect('height')" required data-vv-as="Height">
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex lg4 md4 xs12>
                                                <v-text-field label="Length (ft)" v-model="form.length" v-validate="{decimal:2, decimal_digit: 'form.length'}" data-vv-name="length" placeholder="" :error-messages="errors.collect('length')" required data-vv-as="Length">
                                                </v-text-field>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                            <v-flex lg4 md4 xs12>
                                                <v-text-field label="Rate" v-model="form.rate" v-validate="{rate: 'form.rate','restrictedWord':[]}" data-vv-name="rate" placeholder="" :error-messages="errors.collect('rate')" required data-vv-as="Rate">
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex lg4 md4 xs12>
                                                <v-text-field label="Quantity *" :maxlength="2" v-model="form.quantity" v-validate="{required: 'form.quantity', numeric: 'form.quantity', alpha_dash: 'form.quantity', 'max': 2}" data-vv-name="quantity" placeholder="" :error-messages="errors.collect('quantity')" required data-vv-as="Quantity">
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex lg4 md4 xs12>
                                                <v-text-field label="Number of Stops" :maxlength="2" v-model="form.num_stops" v-validate="{numeric: 'form.num_stops', alpha_dash: 'form.num_stops', 'max': 2}" data-vv-name="num_stops" placeholder="" :error-messages="errors.collect('num_stops')" required data-vv-as="Number of Stops">
                                                </v-text-field>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                            <v-flex lg12 md12 xs12>
                                                <v-textarea label="Description" v-model="form.description" data-vv-name="description" placeholder="" v-validate="{'restrictedWord':[]}" :error-messages="errors.collect('description')" required>
                                                </v-textarea>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                            <v-flex lg4 md4 xs12>
                                                <v-text-field label="Contact Name" :maxlength="64" v-model="form.contact_name" v-validate="{'max': 30,'restrictedWord':[]}" data-vv-name="contact_name" placeholder="" :error-messages="errors.collect('contact_name')" required data-vv-as="Contact Name">
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex lg4 md4 xs12>
                                                <v-text-field label="Contact Email" :maxlength="64" v-model="form.contact_email" v-validate="{email: 'form.contact_email', 'max': 30}" data-vv-name="contact_email" placeholder="" :error-messages="errors.collect('contact_email')" required data-vv-as="Contact Email">
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex lg4 md4 xs12>
                                                <v-text-field label="Contact Phone" v-model="form.contact_phone" v-validate="{numeric:'form.contact_phone', custom_contact:'form.contact_phone'}" data-vv-name="contact_phone" placeholder="" :error-messages="errors.collect('contact_phone')" required data-vv-as="Contact Phone" :mask="`${contactNumberMaskForInput}`">
                                                </v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </div>
                                </v-expand-transition>
                                <v-layout >
                                    <v-flex xs12 class="text-xs-center orange--text" pt-0 pb-0>
                                        <p v-if="!showAdvancedField" flat small @click="showAdvancedField= !showAdvancedField">
                                            ADVANCED </br>
                                            <v-icon color="orange">fa fa-angle-down</v-icon>
                                        </p>
                                        <p v-else flat small @click="showAdvancedField = !showAdvancedField">
                                            ADVANCED </br>
                                            <v-icon color="orange">fa fa-angle-up</v-icon>
                                        </p>
                                    </v-flex>
                                  
                                </v-layout>
                                
                            </v-container>
                            
                        </v-form>
                    </v-card-text>
               
              
            </v-flex>
            
            <v-flex lg7 md4 xs12 pa-0 ma-0></v-flex>
            <v-flex lg2 md4 xs12  ma-0 pt-0 order-lg1  order-xs2 class="text-xs-right">
                <v-btn class='btncancel' color="gray white--text" :to="{name:'Loads'}"><v-icon color="white">fa-times-circle</v-icon> Cancel</v-btn>
            </v-flex>
            <v-flex lg3 md4 xs12 ma-0 pt-0 order-lg2 order-xs1 >
                <span >
                    <v-overflow-btn class="customSegment" append-icon="saveDropDown fa fa-angle-up"
                        prepend-icon="fa-cube"
                        :items="getSaveAsOptions()" label="Save As" segmented item-text="text" item-value="key" v-model="selectedButtonOption" v-on:change="trrigerAction">
                    </v-overflow-btn>
                </span>
            </v-flex>                                    
                                           </v-layout>
                                           
    </v-container>
     </v-card>
    <GoogleAds></GoogleAds>
</div>
</template>
<script>
window.onbeforeunload = function () {
    alert("Do you really want to close?");
};
const ADDRESS_COMPONENTS = {
    subpremise: 'short_name',
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'long_name',
    administrative_area_level_2: 'long_name',
    country: 'long_name',
    postal_code: 'short_name'
};
import GoogleAds from "@/pages/widgets/GoogleAds";
import services from "../../services/HttpService";
import breadcrumbs from "../widgets/Breadcrumb";
import axios from "axios";
import VWidget from '@/components/VWidget';
import utils from "../../util";
import {
    ErrorBag
} from 'vee-validate';
import {
    Validator
} from 'vee-validate';
import moment from 'moment';
import config from "../../config";
Validator.extend('origin_address', {
    getMessage: field => 'The ' + field + ' field is Invalid.',
    validate: function (value, [oth]) {
        if (oth == '') {
            return false;
        }
        return true;
    }
});

Validator.extend('endDateValidationForFrequency', {
    getMessage: field => 'As per recurring type - End date is invalid.',
    validate: function (frequency, [endDate, pickupDate, isRecurring]) {
        let unixEndDate = moment(endDate).unix();
        let unixpickupDate = moment(pickupDate).unix();
        let unixpickupDatePlusOneWeek = moment(moment(pickupDate).add(7, 'days').format('YYYY-MM-DD')).unix();
        let unixpickupDatePlusOneMonth = moment(moment(pickupDate).add(1, 'months').format('YYYY-MM-DD')).unix();

        if (isRecurring && unixEndDate < unixpickupDate) {
            return false;
        } else if (isRecurring && frequency == 'daily' && unixEndDate < unixpickupDate) {
            return false;
        } else if(isRecurring && frequency == 'weekly' && unixpickupDatePlusOneWeek > unixEndDate){
            return false;
        } else if(isRecurring && frequency == 'monthly' && unixpickupDatePlusOneMonth > unixEndDate){
            return false;
        }
        return true;
    }
});

Validator.extend('endDateValidationForPickup', {
    getMessage: field => 'As per recurring type - Pickup date is invalid.',
    validate: function (pickupDate, [endDate, frequency, isRecurring]) {
        let unixEndDate = moment(endDate).unix();
        let unixpickupDate = moment(pickupDate).unix();
        let unixpickupDatePlusOneWeek = moment(moment(pickupDate).add(7, 'days').format('YYYY-MM-DD')).unix();
        let unixpickupDatePlusOneMonth = moment(moment(pickupDate).add(1, 'months').format('YYYY-MM-DD')).unix();

        if (isRecurring && unixEndDate < unixpickupDate) {
            console.log('1')
            return false;
        } else if (isRecurring && frequency == 'daily' && unixEndDate < unixpickupDate) {
            console.log('2')
            return false;
        } else if(isRecurring && frequency == 'weekly' && unixpickupDatePlusOneWeek > unixEndDate){
            console.log('3')
            return false;
        } else if(isRecurring && frequency == 'monthly' && unixpickupDatePlusOneMonth > unixEndDate){
            console.log('4')
            return false;
        }
        return true;
    }
});

Validator.extend('endDateValidation', {
    getMessage: field => 'As per recurring type - End date is invalid.',
    validate: function (endDate, [pickupDate, frequency, isRecurring]) {
        let unixEndDate = moment(endDate).unix();
        let unixpickupDate = moment(pickupDate).unix();
        let unixpickupDatePlusOneWeek = moment(moment(pickupDate).add(7, 'days').format('YYYY-MM-DD')).unix();
        let unixpickupDatePlusOneMonth = moment(moment(pickupDate).add(1, 'months').format('YYYY-MM-DD')).unix();

        if (isRecurring && unixEndDate < unixpickupDate) {
            return false;
        } else if (isRecurring && frequency == 'daily' && unixEndDate < unixpickupDate) {
            return false;
        } else if(isRecurring && frequency == 'weekly' && unixpickupDatePlusOneWeek > unixEndDate){
            return false;
        } else if(isRecurring && frequency == 'monthly' && unixpickupDatePlusOneMonth > unixEndDate){
            return false;
        }
        return true;
    }
});
Validator.extend('origin_city_check', {
    getMessage: field => config.validationMsgForCityCheck,
    validate: function (value, [city, state]) {
        return true;
    }
});
Validator.extend('dest_city_check', {
    getMessage: field => config.validationMsgForCityCheck,
    validate: function (value, [city, state]) {
        return true;
    }
});
Validator.extend('decimal_digit', {
    getMessage: field => 'The field ' + field + ' may not be greater than 4 characters.',
    validate: function (value) {
        if (parseInt(value).toString().length > 4) {
            return false;
        }
        return true;
    }
});
Validator.extend('decimal_digit6', {
    getMessage: field => 'The field ' + field + ' may not be greater than 6 characters.',
    validate: function (value) {
        if (parseInt(value).toString().length > 6) {
            return false;
        }
        return true;
    }
});
Validator.extend('dest_address', {
    getMessage: field => 'The ' + field + ' field is Invalid.',
    validate: function (value, [oth]) {
        if (oth == '') {
            return false;
        }
        return true;
    }
});
Validator.extend('dest_address_mismatch', {
    getMessage: field => config.validationMsgForOriginDestNotSame,
    validate: function (value, [origin_lat, origin_lng, dest_lat, dest_lng]) {
        if (origin_lat != '' && dest_lat != '' && origin_lng != '' && dest_lng != '' && origin_lat == dest_lat && origin_lng == dest_lng) {
            return false;
        }
        return true;
    }
});
Validator.extend('dateValidation', {
    getMessage: field => config.validationMsgForDropOffAndPickupDate,
    validate: function (value, [pickup_date,delivery_date]) {
        if (pickup_date > delivery_date) {
            return false;
        }
        return true;
    }
});
Validator.extend('rate', {
    getMessage: field => config.validationMsgForAlphabetNotAllow,
    validate: function (value) {
        let checkRegex = /^[A-za-z0-9\$]+(\.[A-za-z0-9\$]+)?$/;
        if(!checkRegex.test(value)){
            return false;
        }
        else {
            return true;
        }
        
    }
});
export default {
    $_veeValidate: {
        validator: 'new'
    },
    beforeRouteLeave(to, from, next) {
        if (to.name === 'Login') {
            next();
        } else {
            next();
        }
    },
    data: () => ({
        canLeaveWithoutPrompt: false,
        contactNumberMaskForInput:config.contactNumberMaskForInput,
        selectedButtonOption:{
            key: 'postload',
            text: 'Post Load'
        },
        form: {
            origin_address: '',
            origin_country: '',
            origin_state: '',
            origin_city: '',
            origin_pincode: '',
            origin_lat: '',
            origin_lng: '',
            origin_short_name: '',
            dest_address: '',
            dest_country: '',
            dest_state: '',
            dest_city: '',
            dest_pincode: '',
            dest_lat: '',
            dest_lng: '',
            dest_short_name: '',
            pickup_date: new Date().toISOString().substr(0, 10),
            muiti_pickup_date: [],
            end_date: new Date().toISOString().substr(0, 10),
            is_recurring: false,
            frequency: 'daily',
            delivery_date: new Date().toISOString().substr(0, 10),
            weight: '',
            height: '',
            length: '',
            equipment_type_id: '',
            type: '',
            rate: '',
            quantity: 1,
            num_stops: 1,
            load_size: 'FULL',
            description: '',
            contact_name: '',
            contact_email: '',
            contact_phone: '',
            reference_number: '',
            save_as_template: false,
            template_id: '',
            distance: '',
            save_type: '',
            template_name: ''
        },
        equipment_type_id_list: [],
        picker_pickup_date: false,
        muiti_pickup_date_chips: [],
        picker_end_date: false,
        picker_delivery_date: false,
        hidden_origin_address: '',
        hidden_origin_city: '',
        hidden_origin_state: '',
        hidden_dest_address: '',
        hidden_dest_city: '',
        hidden_dest_state: '',
        equipment_types: [],
        load_size_arr: [{
            name: 'ANY',
            id: 'ANY'
        }, {
            name: 'LTL',
            id: 'LTL'
        }, {
            name: 'FULL',
            id: 'FULL'
        }],
        templates: [],
        frequency: [{text:'Daily', value:'daily'},{text:'Weekly', value:'weekly'},{text:'Monthly', value:'monthly'}],
        types: [],
        formData: {},
        showTemplates: true,
        showEquipmentTypes: true,
        origin_autocomplete: null,
        showTemplateModal: false,
        showAdvancedField: false,
        breadcrumbs: [{
                name: 'Dashboard',
                to: "/dashboard",
                disabled: false
            },
            {
                name: 'Broker/Shipper',
                disabled: true
            },
            {
                name: 'My Loads',
                to: "/loads/list",
                disabled: false
            },
            {
                name: 'Post Load',
                disabled: true
            }
        ]
    }),
    components: {
        breadcrumbs,
        VWidget,
        GoogleAds
    },
    mounted() {
        const self = this;
        self.form.muiti_pickup_date.push(new Date().toISOString().substr(0, 10));
        self.muiti_pickup_date_chips.push(moment(new Date().toISOString().substr(0, 10)).format("MMM DD, YYYY"));
        // self.form.pickup_date = moment(self.form.pickup_date).format("MMM DD, YYYY");
        setTimeout(function() {
            if(document.getElementById('origin_address')){
                document.getElementById('origin_address').setAttribute('autocomplete', 'disabled');
            }
            if(document.getElementById('dest_address')){
                document.getElementById('dest_address').setAttribute('autocomplete', 'disabled');
            }
        }, 1000);
        self.form.contact_name = self.$store.state.user.name;
        self.form.contact_phone = self.$store.state.user.alternate_phone_no;
        self.$validator.localize('en', self.dictionary);
        // google place api for origin address
        const options = {};
        self.origin_autocomplete = new google.maps.places.Autocomplete(
            document.getElementById('origin_address'),
            options
        );
        self.origin_autocomplete.setComponentRestrictions({
            'country': ['CAN', 'US']
        });
        self.origin_autocomplete.addListener('place_changed', function () {
            let place = self.origin_autocomplete.getPlace();
            if (place.address_components !== undefined) {
                utils.formatResult(place, 'origin_', self);
            } else {
                self.hidden_origin_address = '';
                self.hidden_origin_city = '';
                self.hidden_origin_state = '';
            }
        });

        // google place api for destination address
        const options1 = {};
        self.dest_autocomplete = new google.maps.places.Autocomplete(
            document.getElementById('dest_address'),
            options1
        );
        self.dest_autocomplete.setComponentRestrictions({
            'country': ['CAN', 'US']
        });
        self.dest_autocomplete.addListener('place_changed', function () {
            let place = self.dest_autocomplete.getPlace();
            if (place.address_components !== undefined) {
                utils.formatResult(place, 'dest_', self);
                self.$validator.validate('origin_address');
            } else {
                self.hidden_dest_address = '';
                self.hidden_dest_city = '';
                self.hidden_dest_state = '';
                this.$validator.validate('dest_address');
            }
        });
    },
    created() {
        const self = this,
            wApp = window.getApp;
        wApp.$emit("showLoader", {
            show: true
        });
        self.utils = utils;
        axios.all([
                services.get("loads/templates/list", {
                    'Authorization': 'Bearer ' + this.$store.state.user.token
                }),
                services.get("equipments/list", {
                    'Authorization': 'Bearer ' + this.$store.state.user.token
                }),
            ])
            .then(axios.spread(function (templates, equipment_types) {
                wApp.$emit("showLoader", {
                    show: false
                });
                if (templates.data.data.length > 0) {
                    self.templates.push({
                        'template_name': 'Please Select Template',
                        'uuid': ''
                    });
                    templates.data.data.map(function (data) {
                        let newArr = {};
                        newArr.template_name = data.template_name;
                        newArr.uuid = data.uuid;
                        self.templates.push(newArr);
                    })
                } else {
                    self.showTemplates = false;
                }
                if (equipment_types.data.data.length > 0) {
                    self.equipment_types.push({
                        'name': config.ANYStr,
                        'code': config.ANYStr
                    });
                    equipment_types.data.data.map(function (data) {
                        let newArr = {};
                        newArr.name = data.name;
                        newArr.code = data.code;
                        self.equipment_types.push(newArr);
                        if(data.code == 'VAN'){
                            self.equipment_type_id_list.push(data.code);
                        }
                    })
                } else {
                    self.showEquipmentTypes = false;
                }
            }))
            .catch(function (err) {
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, config.errMsgColorStr);
            });
    },
    computed: {
        minDate() {
            const today = new Date();
            return this.formatDate(today);
        },
    },
    methods: {
        displayDate(selectedDate,type){
            if((type==config.typeDelivery && this.form.delivery_date && this.form.delivery_date.length > 0) || (type==config.typePickup && this.form.pickup_date)){
                return moment(selectedDate).format(config.displayDateFormat);
            }
            return '';
        },
        // endDateValidation(){
        //     const self = this;

        // },
        changeMultiDate(){
            const self = this;
            self.$refs.picker_muiti_pickup_date.originalValue = self.form.muiti_pickup_date;
            self.muiti_pickup_date_chips = []
            self.form.muiti_pickup_date.map(function(date){
                self.muiti_pickup_date_chips.push(moment(date).format(config.displayDateFormat));
            });
        },
        isRecurringChange(data){
            if(data){
                this.form.end_date = this.form.pickup_date;
                this.form.frequency = 'daily';   
            }
        },
        getAddressData(data) {
            const self = this;
            self['hidden_' + data + '_address'] = '';
            self['hidden_' + data + '_city'] = '';
            self['hidden_' + data + '_state'] = '';
            this.$validator.validate(data + '_address');
        },
        changeFrequency(data) {
            // console.log(data)
        },
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        distanceOrgToDest(lat1, lon1, lat2, lon2, cb) {
            const self = this;
            if ((lat1 == lat2) && (lon1 == lon2)) {
                self.form.distance = 0;
                return 0;
            } else {
                var origin1 = new google.maps.LatLng(lat1, lon1);
                var destinationB = new google.maps.LatLng(lat2, lon2);
                let inMiles = 0;
                var distanceService = new google.maps.DistanceMatrixService();
                distanceService.getDistanceMatrix({
                        origins: [origin1, ''],
                        destinations: [destinationB, ''],
                        travelMode: google.maps.TravelMode.DRIVING,
                        unitSystem: google.maps.UnitSystem.IMPERIAL,
                        durationInTraffic: true,
                        avoidHighways: false,
                        avoidTolls: false
                    },
                    function (response, status) {
                        if (status !== google.maps.DistanceMatrixStatus.OK) {
                            cb(inMiles);
                        } else {
                            if(response.rows[0].elements[0].status === 'ZERO_RESULTS'){
                                var radlat1 = Math.PI * lat1 / 180;
                                var radlat2 = Math.PI * lat2 / 180;
                                var theta = lon1 - lon2;
                                var radtheta = Math.PI * theta / 180;
                                var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                                if (dist > 1) {
                                    dist = 1;
                                }
                                dist = Math.acos(dist);
                                dist = dist * 180 / Math.PI;
                                dist = dist * 60 * 1.1515;
                                inMiles = dist * 0.8684;
                            } else {
                                inMiles = parseFloat(response.rows[0].elements[0].distance.value / 1609.34).toFixed(2);
                            }
                            cb(inMiles);
                        }
                    });
            }
        },
        beforeSubmitLoad(save_type) {
            const self = this;
            self.$validator.validateAll().then(isValid => {
                if (isValid) {
                    self.showTemplateModal = true;
                    self.form.save_type = save_type;
                } else {
                    self._showToast(config.errMsgFormSubmitValidation, config.errMsgColorStr);
                }
            });
        },
        submit(save_type) {
            const self = this;
            const wApp = window.getApp;
            if(!self.form.is_recurring){
                self.form.pickup_date = self.form.muiti_pickup_date.join();
            }
            if (save_type) {
                self.form.save_type = save_type;
            }
            self.$validator.validateAll().then(isValid => {
                if (isValid) {
                    wApp.$emit("showLoader", {
                        show: true
                    });
                    self.distanceOrgToDest(self.form.origin_lat, self.form.origin_lng, self.form.dest_lat, self.form.dest_lng, function (dist) {
                        self.form.distance = dist;
                        if(self.equipment_type_id_list[0].code != config.ANYStr){
                            self.form.equipment_type_id = self.equipment_type_id_list.join(',');
                        }
                        else {
                            self.form.equipment_type_id = config.ANYStr;
                        }
                        if(!self.form.is_recurring){
                            self.form.frequency = null;
                        }
                        services.post("loads/new", self.form, {"Authorization": "Bearer " + self.$store.state.user.token}).then(res => {
                            wApp.$emit("showLoader", {
                                show: false
                            });
                            if (!res.data.is_err) {
                                self._showToast(res.data.message);
                                self.canLeaveWithoutPrompt = true;
                                self.$router.push({
                                    name: "Loads",
                                    params: {
                                        selectedTab: self.form.save_type
                                    }
                                });
                            } else {
                                self._showToast(res.data.message, config.errMsgColorStr);
                            }
                        })
                        .catch(err => {
                            wApp.$emit("showLoader", {
                                show: false
                            });
                            self._showToast(err.response.data.message, config.errMsgColorStr);
                        });
                    });
                } else {
                    self._showToast(config.errMsgFormSubmitValidation, config.errMsgColorStr);
                }
            })
        },
        clear() {
            this.form = {};
            this.$validator.reset();
        },
        getSaveAsOptions() {
            const self = this;
            if (self.form.template_id) {
                return [
                    {
                        key: 'postload',
                        text: 'POST LOAD',
                        callback: () => this.submit('postload')
                    },
                    {
                        key: 'addtemplate',
                        text: 'CREATE TEMPLATE',
                        callback: () => self.beforeSubmitLoad('addtemplate')
                    },
                    {
                        key: 'updatetemplate',
                        text: 'UPDATE TEMPLATE',
                        callback: () => self.submit('updatetemplate')
                    },
                    {
                        key: 'postloadandtemplate',
                        text: 'CREATE AND POST',
                        callback: () => self.beforeSubmitLoad('postloadandtemplate')
                    },
                    {
                        key: 'postloadupdatetemplate',
                        text: 'UPDATE AND POST',
                        callback: () => self.submit('postloadupdatetemplate')
                    },
                ]
            } else {
                return [
                    {
                        key: 'postload',
                        text: 'POST LOAD',
                        callback: () => this.submit('postload')
                    },
                    {
                        key: 'addtemplate',
                        text: 'CREATE TEMPLATE',
                        callback: () => self.beforeSubmitLoad('addtemplate')
                    },
                    {
                        key: 'postloadandtemplate',
                        text: 'CREATE AND POST',
                        callback: () => self.beforeSubmitLoad('postloadandtemplate')
                    },
                ]

            }
        },
        onTemplateChange(data) {
            if (!data) {
                return;
            }
            const self = this,
                wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            services.post("loads/templates/templatebyuuid", {template_id: data}, {"Authorization": "Bearer " + self.$store.state.user.token}).then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                if (!res.data.is_err) {
                    delete res.data.data[0].template_name;
                    self.form.template_id = data;
                    self.hidden_origin_address = res.data.data[0].origin_address;
                    self.hidden_dest_address = res.data.data[0].dest_address;
                    self.hidden_dest_city = res.data.data[0].dest_city;
                    self.hidden_origin_city = res.data.data[0].origin_city;
                    self.hidden_dest_state = res.data.data[0].dest_state;
                    self.hidden_origin_state = res.data.data[0].origin_state;
                    self.form = Object.assign({}, self.form, res.data.data[0]);
                    let equipmentSelected = res.data.data[0].equipment_type_id.split(',');
                    self.equipment_type_id_list = [];
                    equipmentSelected.map(function (data) {
                        self.equipment_type_id_list.push(data);
                    });
                    if(res.data.data[0].frequency != 'NULL'){
                        self.form.is_recurring = true;
                        console.log('res.datares.data',res.data.data[0].frequency)
                    } else {
                        self.form.is_recurring = false;
                    }
                    setTimeout(function () {
                        self.$validator.validateAll()
                            .then(isValid => {
                            })
                    }, 100)
                } else {
                    self._showToast(res.data.message, config.errMsgColorStr);
                }
            })
            .catch(err => {
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, config.errMsgColorStr);
            });
        },
        onEquipmentChange(data) {
            const self = this;
            if(data != ''){
                let selectedEquipmentCode = data.toString().split(',');
                self.equipment_type_id_list = [];
                if(selectedEquipmentCode[(selectedEquipmentCode.length -1)]==config.ANYStr){
                    self.equipment_type_id_list.push(config.ANYStr);
                }else{
                    selectedEquipmentCode.map(async function (equipmentCode) {
                        if(equipmentCode != config.ANYStr){
                            await self.equipment_type_id_list.push(equipmentCode);
                        }        
                    });
                }
            }
        },
        changePickerDate() {
            const self = this;
            let evt = document.createEvent("HTMLEvents");
            evt.initEvent("input", false, true);
            setTimeout(function () {
                document.getElementById('pickup_date').dispatchEvent(evt);
            }, 10)
        },
        changeDeliveryDate() {
            const self = this;
            let evt = document.createEvent("HTMLEvents");
            evt.initEvent("input", false, true);
            setTimeout(function () {
                document.getElementById('delivery_date').dispatchEvent(evt);
            }, 10)
        },
        formatDate(date) {
            let month = `${date.getMonth() + 1}`;
            let day = `${date.getDate()}`;
            const year = date.getFullYear();

            if (month.length < 2) month = `0${month}`;
            if (day.length < 2) day = `0${day}`;

            return [year, month, day].join('-');
        },
        trrigerAction(data) {
            const self = this;
            console.log(this.form)
            if(data === 'addtemplate' || data === 'postloadandtemplate'){
                self.$validator.validateAll()
                .then(isValid => {
                    if (isValid) {
                        self.form.save_type = data;
                    } else {
                        self._showToast(config.errMsgFormSubmitValidation,config.errMsgColorStr);
                    }
                });
                self.beforeSubmitLoad(data);
            }
            else {
                self.showTemplateModal = false;
                self.submit(data);
            }
        }
    }
};
</script>
<style lang="stylus" scoped>
.payment-method {
    border: 1px solid #eee
}
.link-btn{
    box-shadow:none !important;
}
:-ms-input-placeholder { /* IE 10+ */
  color: green;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/loads/Add.vue